

    /**
     * ES6 Number.isNaN
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
     */
    function isNaN(val){
        // jshint eqeqeq:false
        return typeof val === 'number' && val != val;
    }

    module.exports = isNaN;





//////////////////
// WEBPACK FOOTER
// ./~/mout/number/isNaN.js
// module id = 704
// module chunks = 0 1 2